import { Partner } from '$lib/types/Partner'
import { writable } from 'svelte/store'

export const partnerStore = writable<Partner | null>(null)

const urlCache = new Map<string, Partner>()

export const setPartner = (url: string, partner: Partner) => {
    urlCache.set(url, partner)
}

export const getCurrentPartnerByUrl = (url: string) => {
    return urlCache.get(url)
}
